module.exports = __webpack_public_path__ + "img/box-agency.bec313ad.png";